import { Component } from 'react';
import PropTypes from 'prop-types';
import { BREAKPOINT_X_LARGE_IN_PX } from '../../constants';

export default class AppDidUpdate extends Component {
  componentDidUpdate(prevProps) {
    const {
      autoOpenArticleInfo,
      clientSize: { width: currWidth },
      openArticleInfoPanel,
    } = this.props;

    const {
      clientSize: { width: prevWidth },
    } = prevProps;

    if (
      prevWidth === 0
      && currWidth >= BREAKPOINT_X_LARGE_IN_PX
      && autoOpenArticleInfo
    ) {
      openArticleInfoPanel();
    }

    // 300ms is required to wait for the side panel to open or close
    setTimeout(() => {
      prevProps.setButtonListWidth();
      prevProps.setListContainerWidth();
    }, 300);
  }

  render() {
    return null;
  }
}

AppDidUpdate.propTypes = {
  autoOpenArticleInfo: PropTypes.bool.isRequired,
  clientSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  setButtonListWidth: PropTypes.func.isRequired,
  setListContainerWidth: PropTypes.func.isRequired,
  openArticleInfoPanel: PropTypes.func.isRequired,
};
